import type { FaireProductEntity } from "../../entity_types/product";

export const p_vb3mpd4dua: FaireProductEntity = {
  token: "p_vb3mpd4dua",
  type: "product",
  name: "Wool Dryer Balls",
  brandToken: "b_8aa5kchc2z",
  brandName: "Homecourt",
  imageUrl:
    "https://cdn.faire.com/fastly/affe3659bbc1535dde0a02d0f3028b1b1aa3526b4684bcf5b6ec27f7bf037ca9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bc0965032b982f7a959ada0fde397b5678b1b4a415c3ade5ad310f2897a682eb.jpeg",
    "https://cdn.faire.com/fastly/7aa22362d42874e2914e321836415f34fdd1f9d6f762e8d9cc1cfa45e6018034.jpeg",
  ],
  priceDollars: 13.2,
  description:
    "Naturally soften fabrics, reduce wrinkles, and cut drying time with our Wool Dryer Balls. Made from 100% New Zealand lamb wool, this set includes two natural and two gray balls—light for whites, gray for colors and darks.\n\nDesigned for use with Homecourt Laundry Fragrance Oil, they gently enhance your laundry with every tumble. Stored in a convenient drawstring bag, they’re a reusable, eco-friendly alternative to dryer sheets.\n\n• Includes: Drawstring storage bag, 4 x wool balls\n• Shop The Laundry Fragrance Oil",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-28T15:36:21.513Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
